import css from '@/server/components/Button/Button.module.scss';

export const variantClassnames = {
  default: '',
  outline: css.outline,
  highlighter: css.highlighter,
  square: css.square,
  homeThemed: css.themed,
};

export const sizeClassnames = { sm: css.sm, md: css.md, lg: css.lg, xl: css.xl, xxl: css.xxl };

export const sizeMap = { sm: 24, md: 32, lg: 42, xl: 62, xxl: 240 };

export type IconSize = keyof typeof sizeClassnames;
